import { useContext } from 'react';
import { type Auth, AuthContext } from '../provider';

export function useAuth(): Auth {
	const context = useContext(AuthContext);
	if (context === undefined) {
		throw new Error('useAuth must be used within a AuthProvider');
	}
	return context;
}
